import * as React from "react"
const Sports = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M16.276 2.688C8.855 2.688 2.84 8.703 2.84 16.124s6.016 13.438 13.437 13.438c7.422 0 13.438-6.016 13.438-13.438 0-7.422-6.016-13.438-13.438-13.438Zm-2.588 2.31a11.457 11.457 0 0 1 5.176 0l-2.585 1.55-2.59-1.55Zm-2.459.878 4.042 2.419v2.947l-3.75 2.725-2.747-.95-.789-4.749a11.457 11.457 0 0 1 3.244-2.392Zm-4.91 4.652.481 2.899-1.919 1.919c.114-1.693.605-3.34 1.438-4.818Zm-1.3 7.53 3.126-3.126 2.742.947 1.452 4.479-1.303 2.116-4.425-.26a11.349 11.349 0 0 1-1.593-4.155Zm3.318 6.276 2.559.15.907 2.153a11.43 11.43 0 0 1-3.466-2.303Zm5.965 3.042-1.59-3.774 1.293-2.106h4.532l1.225 2.124-1.397 3.736a11.495 11.495 0 0 1-4.063.02Zm6.49-.756.763-2.039 2.244.141a11.426 11.426 0 0 1-3.008 1.898h.002Zm4.747-3.809-4.064-.255-1.26-2.182 1.46-4.495 2.706-.935 3.106 3.386a11.367 11.367 0 0 1-1.948 4.482Zm2.147-7.244-1.935-2.11.487-2.926a11.355 11.355 0 0 1 1.448 5.036Zm-3.115-7.296-.791 4.749-2.741.947-3.75-2.725V8.294l4.033-2.42c1.217.601 2.317 1.412 3.25 2.397Zm-11.697 7.205 3.406-2.475 3.407 2.475-1.3 4.004h-4.212l-1.301-4.004Z"
    />
  </svg>
)
export default Sports